import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import FocusTrap from 'focus-trap-react';
import styled from 'styled-components';
const noop = () => undefined;
export const FullScreenTemplate = _ref => {
  let {
    children,
    open = false,
    onClose = noop,
    closeOnEsc = true,
    zIndex = 9,
    pauseFocusTrap = false,
    ...containerProps
  } = _ref;
  const handleClose = () => {
    if (closeOnEsc) {
      onClose();
    }
  };
  const keyListenersMap = new Map([['Escape', handleClose]]);
  useEffect(() => {
    const keyListener = e => {
      const listener = keyListenersMap.get(e.key);
      return listener && listener(e);
    };
    document.addEventListener('keydown', keyListener);
    return () => document.removeEventListener('keydown', keyListener);
  });
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [open]);
  if (open) {
    return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(FocusTrap, {
      paused: pauseFocusTrap
    }, /*#__PURE__*/React.createElement(FullScreenContainer, _extends({}, containerProps, {
      zIndex: zIndex
    }), /*#__PURE__*/React.createElement(ForceFocus, {
      tabIndex: 0,
      role: "presentation"
    }, children))), document.body);
  }
  return null;
};
const FullScreenContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "FullScreenTemplate__FullScreenContainer",
  componentId: "sc-lgcfv3-0"
})(["background:white;position:fixed;height:100%;width:100%;left:0;top:0;right:0;bottom:0;z-index:", ";"], _ref2 => {
  let {
    zIndex
  } = _ref2;
  return zIndex;
});
const ForceFocus = /*#__PURE__*/styled.div.withConfig({
  displayName: "FullScreenTemplate__ForceFocus",
  componentId: "sc-lgcfv3-1"
})(["height:100%;width:100%;left:0;top:0;right:0;bottom:0;outline:none;"]);